import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo } from "preact/hooks";
import PlanInputRadio from "./PlanInputRadio";
const PreservePlanComponent = ({ plans, onChange, value }) => {
    const isVisible = useMemo(() => {
        return plans.length > 0;
    }, [plans]);
    const handleInput = (selected) => {
        onChange(selected);
    };
    return (_jsxs("section", Object.assign({ class: `SchedulePayComponent__container ${isVisible ? '' : 'hide'}`, id: "PreservePlanComponent" }, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u30D7\u30E9\u30F3\u30FB\u30B5\u30FC\u30D3\u30B9"] }), void 0),
            _jsxs("div", Object.assign({ class: "field control" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u3054\u5E0C\u671B\u306E\u30D7\u30E9\u30F3\u30FB\u30B5\u30FC\u30D3\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0),
                    _jsx("ul", Object.assign({ class: "ml3" }, { children: plans.map(plan => {
                            return (_jsx("li", { children: _jsx(PlanInputRadio, { onInput: handleInput, value: plan, selected: value?.id }, void 0) }, void 0));
                        }) }), void 0)] }), void 0)] }), void 0));
};
export default PreservePlanComponent;
